import { Component, OnInit, inject, ChangeDetectionStrategy, signal, input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import {IecTaskService} from '../services/iec-task-service';
import {PersonLoginService} from '../services/person-login-service';
import {TaskResponseService} from '../services/task-response-service';
import {StringUtils} from '../utils/string-utils';
import {IecTask} from './iec-task';
import {TaxStatusResponse} from './tax-status-response';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';
import {FormsModule} from '@angular/forms';


@Component({
    selector: 'tax-status-request-task',
    templateUrl: './tax-status-request-task.component.html',
    styleUrls: ['./tax-status-request-task.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatButton, MatIcon, MatProgressSpinner]
})
export class TaxStatusRequestTaskComponent implements OnChanges, OnInit {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly taskResponseService = inject(TaskResponseService);
  private readonly iecTaskService = inject(IecTaskService);
  private readonly router = inject(Router);
  readonly taskId = input.required<string>({ alias: 'task-id' });


  readonly task = signal<IecTask>(undefined!);
  response!: TaxStatusResponse;
  readonly isBusy = signal<boolean>(false);
  readonly errorMessage = signal<string>(undefined!);

  ngOnInit(): void {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    } else {
      this.response = new TaxStatusResponse();
      this.personLoginService.getCachedLogin();
      this.initialize();
    }
  }

  saveResponse(): void {
    this.isBusy.set(true);
    this.taskResponseService.taxStatusRequest(this.task().id, this.response).subscribe(() => this.router.navigate(['main']), error => this.handleError(error));
  }

  private handleError(error: any) {
    this.errorMessage.set(StringUtils.getErrorMessage(error));
    this.isBusy.set(false);
  }


  private initialize(): void {
    let taskIdString: string = this.taskId();
    if (taskIdString && !isNaN(+taskIdString) && +taskIdString > 0) {
      this.iecTaskService.getTask(+taskIdString).subscribe(result => this.task.set(result), error => this.handleError(error));
    } else {
      this.router.navigate(['main']);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['taskId'].firstChange) {
      this.initialize();
    }
  }
}
